import React from 'react';
import PageBuilder from '@digital/page-builder';
import '@digital/page-builder/lib/es/styles.css';

const PageBuilderPage = () => <PageBuilder />;

export default PageBuilderPage;
